import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-447a4b24"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "divMainTitle",
  class: "mainTitle-div"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = {
  key: 0,
  class: "news-div"
}
const _hoisted_4 = { class: "grid-parent-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px","margin-top":"30px"} }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "fs-4",
    style: {"text-align":"left","margin-left":"5%","font-weight":"bold","font-size":"2em","color":"#00368f"}
  }, "What's New")
], -1 /* HOISTED */))
const _hoisted_6 = { style: {"height":"500px","border":"2px solid #ccc","margin-left":"5%","width":"95%","overflow-y":"scroll"} }
const _hoisted_7 = { class: "tblNews" }
const _hoisted_8 = { style: {"text-align":"left","padding-left":"5px","font-weight":"bold","width":"100% !important"} }
const _hoisted_9 = { style: {"text-align":"left","padding-left":"7px","font-weight":"bold"} }
const _hoisted_10 = {
  colspan: "2",
  style: {"text-align":"left","padding":"5px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, [
  /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold","font-size":"1em"} }, "Please make use of this page for your service activities !")
], -1 /* HOISTED */))
const _hoisted_13 = {
  id: "divMenu",
  class: "menu-div"
}
const _hoisted_14 = {
  id: "ulMenu",
  style: {"height":"auto"}
}
const _hoisted_15 = {
  key: 0,
  class: "mordalMainItem MenuStyle"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"black"} }, "○  ", -1 /* HOISTED */))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "bi bi-caret-right-fill"
}
const _hoisted_20 = {
  key: 1,
  class: "bi bi-caret-down-fill"
}
const _hoisted_21 = {
  key: 2,
  class: "mordalMainItemEdit MenuStyle"
}
const _hoisted_22 = {
  key: 3,
  class: "mordalSubItem"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 3,
  style: {"color":"#0d6efd"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($setup.store.getters.showPageTitle + " Page"), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      ($setup.store.getters.isNewsFlg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.getters.newsData, (newsItem, newsIndex) => {
                    return (_openBlock(), _createElementBlock("tbody", { key: newsIndex }, [
                      _createElementVNode("tr", {
                        style: _normalizeStyle({ color: newsItem.importanceColor })
                      }, [
                        _createElementVNode("td", _hoisted_8, " ■ " + _toDisplayString(newsItem.startDate), 1 /* TEXT */)
                      ], 4 /* STYLE */),
                      _createElementVNode("tr", {
                        style: _normalizeStyle({ color: newsItem.importanceColor })
                      }, [
                        _createElementVNode("td", _hoisted_9, _toDisplayString(newsItem.subject), 1 /* TEXT */)
                      ], 4 /* STYLE */),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_10, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsItem.content, (info, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                              _createTextVNode(_toDisplayString(info) + " ", 1 /* TEXT */),
                              _hoisted_11
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ]),
              _hoisted_12
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("ul", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.store.getters.subMenuItem, (mordalMainItem, mordalMainIndex) => {
            return (_openBlock(), _createElementBlock("li", {
              style: {"text-align":"left","width":"400px"},
              id: "mordal",
              class: "mordalBlock",
              key: mordalMainIndex
            }, [
              (mordalMainItem.url != null &&
            mordalMainItem.url != '' &&
            mordalMainItem.url != 'None'
            )
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("a", {
                      href: "#",
                      onClick: ($event: any) => ($setup.openWindow(mordalMainItem))
                    }, _toDisplayString(mordalMainItem.name), 9 /* TEXT, PROPS */, _hoisted_17)
                  ]))
                : (mordalMainItem.data.length != 0)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "mordalMainItemEdit MenuStyle",
                      onClick: ($event: any) => ($setup.toggleSubMainMenuOpen(mordalMainItem))
                    }, [
                      ($setup.store.getters.showedMenuList.includes(mordalMainItem.id) ===
              false
              )
                        ? (_openBlock(), _createElementBlock("i", _hoisted_19))
                        : (_openBlock(), _createElementBlock("i", _hoisted_20)),
                      _createTextVNode(" " + _toDisplayString(mordalMainItem.name), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_18))
                  : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(mordalMainItem.name), 1 /* TEXT */)),
              ($setup.store.getters.showedMenuList.includes(mordalMainItem.id))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mordalMainItem.data, (mordalSubItem, mordalSubIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        id: "mordalSub ",
                        class: "MenuStyle",
                        key: mordalSubIndex
                      }, [
                        (mordalSubItem.url == 'NewsEdit' ||
                mordalSubItem.url == 'NewsAdminEdit' || mordalSubItem.url == 'NewsMailMaintenance'
                )
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              onClick: ($event: any) => ($setup.openNewsFunction(mordalSubItem.url))
                            }, _toDisplayString(mordalSubItem.name), 9 /* TEXT, PROPS */, _hoisted_23))
                          : (mordalSubItem.url != null && mordalSubItem.url != '' && mordalSubItem.id != 'SM0230')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: ($event: any) => ($setup.openWindow(mordalSubItem))
                              }, _toDisplayString(mordalSubItem.name), 9 /* TEXT, PROPS */, _hoisted_24))
                            : (mordalSubItem.url != null && mordalSubItem.url != '' && mordalSubItem.id == 'SM0230')
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 2,
                                  href: "#",
                                  onClick: ($event: any) => ($setup.openWindow(mordalSubItem)),
                                  style: {"color":"red","text-decoration-color":"red"}
                                }, _toDisplayString(mordalSubItem.name), 9 /* TEXT, PROPS */, _hoisted_25))
                              : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(mordalSubItem.name), 1 /* TEXT */))
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ]),
    _createCommentVNode(" </div> ")
  ], 64 /* STABLE_FRAGMENT */))
}